package com.milta.core.localization.translations.ro

import com.milta.core.localization.ErrorStrings

internal val Errors = ErrorStrings(
    generic = "A apărut o eroare",
    error = "Eroare",
    fieldRequired = "Acest câmp este obligatoriu",
    invalidEmail = "Adresă de email invalidă",
    fileTooLarge = "Fișier prea mare. Alegeți un fișier mai ușor.",
)
